import React from "react"
import {useLocal} from "../../AppContext"
import {Button} from "../../Components/Button"
import style from "./Apply.css"

export const Apply = ({onClick, disabled = false}) => {
    const local = useLocal()

    return <div className={style.apply}>
        <Button isDisabled={disabled} onClick={onClick}>{local.__("Übernehmen")}</Button>
    </div>
}